import React, { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import CustomInputField from "../../CustomHTMLElements/CustomInputField";
import { postData } from "../../../newApis/apiMethods";
import { errorHandler } from "../../../helpers/errorHandler";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { yupValidators } from "../../../helpers/yupValidators";
import VerificationLoader from "../RecoveryComponents/VerificationLoader.component";
import { appInsights } from "../../../config/appInsights";

const schema = yup.object().shape({
  otp: yupValidators.otp,
});

export default function RecoveryStepTwo({
  state_token,
  setMultiStepMenu,
  setOtp,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    const { otp } = data;
    setLoading(true);
    setError(null);
    const reqBody = {
      state_token,
      otp,
    };
    try {
      await postData(ajaxEndpoints.RESET_PASSWORD_SECOND_STEP, reqBody);
      setMultiStepMenu("stepThree");
      setOtp(otp);
      setLoading(false);
    } catch (error) {
      appInsights.trackException({
        exception: error,
        properties: {
          fileName: "RecoveryStepTwo.component.jsx",
        },
      });
      setLoading(false);
      setError(errorHandler(error));
    }
  };

  if (loading) {
    return (
      <VerificationLoader
        text="Verifying your OTP"
        iconType="fas fa-question-circle"
      />
    );
  }
  return (
    <div>
      <div className="tfx-step grid__full">
        <div className="tfx-user-form-wrapper box-effect full-border white-bg">
          <div className="tfx-user-form-inner">
            <div id="adv-verify-email">
              <div className="grid__full ">
                <div className="adv-form">
                  <form name="form" onSubmit={handleSubmit(onSubmit)}>
                    <label className="label-txt center-txt">
                      Enter OTP Sent to your Phone & Email
                    </label>
                    {error && (
                      <p className="alert alert-danger mb-4 small">{error}</p>
                    )}

                    <CustomInputField
                      type="password"
                      maxLength="6"
                      reference={register}
                      name="otp"
                      placeholder="Enter OTP"
                      label=""
                      errors={errors.otp}
                      iconType="fas fa-question-circle"
                    />
                    <div className="grid__full mt-20">
                      <div className="grid__full">
                        <button
                          type="submit"
                          className="zoom-element btn login-btn"
                        >
                          <i className="fas fa-envelope" />
                          &nbsp; Verify OTP
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
